module.exports = __webpack_public_path__ + "static/media/Musicicon.0cf38b75.svg";